<script>
import Layout from "../../layouts/main";
//import appConfig from "@/app.config";
import countTo from 'vue-count-to';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  /*page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },*/
  components: {
    Layout,countTo, swiper, swiperSlide
  },
  data() {
    return {

      counterVisible: false,
      keyCounterVisible:0,

      mediaFeaturesVisible: false,
      iconsVisible: false,

      bannerList: [],
      icons: [
        { imgSrc: 'car-3-svgrepo-com', altText: 'default.icons.1.altText', text: 'default.icons.1.text' },
        { imgSrc: 'family-of-3-whole-body-svgrepo-com', altText: 'default.icons.2.altText', text: 'default.icons.2.text' },
        { imgSrc: 'plane-svgrepo-com', altText: 'default.icons.3.altText', text: 'default.icons.3.text' },
        { imgSrc: 'tray-dish-svgrepo-com', altText: 'default.icons.4.altText', text: 'default.icons.4.text' }
      ],

      referencesLogos: [
        { src: require('@/assets/images/references/bte.png'), alt: 'BTE' },
        { src: require('@/assets/images/references/dclean.png'), alt: 'DClean' },
        { src: require('@/assets/images/references/minenv.png'), alt: 'Ministère de l\'environnement' },
        { src: require('@/assets/images/references/mokador.jpeg'), alt: 'Mokador' },
        { src: require('@/assets/images/references/sos.png'), alt: 'SOS Villages d\'Enfants' },
        { src: require('@/assets/images/references/top-protect.jpg'), alt: 'Top Protect' },


        { src: require('@/assets/images/references/pazzino.png'), alt: 'Pazzino' },
        { src: require('@/assets/images/references/business.png'), alt: 'Business Hotel Sfax' },
        { src: require('@/assets/images/references/z.png'), alt: 'The Z Hotel' },
        { src: require('@/assets/images/references/hana.png'), alt: 'Dar El Hana' },
        { src: require('@/assets/images/references/topx.png'), alt: 'TopX' },
        { src: require('@/assets/images/references/maesteria.png'), alt: 'Maesteria' },
        { src: require('@/assets/images/references/top-protect.jpg'), alt: 'Top Protect' },


      ],

      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "users-2-svgrepo-com",
        alt: "users-2-svgrepo-com",
        title: "default.mediaFeatures.1.title",
        description: "default.mediaFeatures.1.description"
      },
      {
        id: "2",
        icon: "qr-code-interactive",
        alt: "qr-code-interactive",
        title: "default.mediaFeatures.2.title",
        description: "default.mediaFeatures.2.description"
      },
      {
        id: "3",
        icon: "target-2-svgrepo-com",
        alt: "target-2-svgrepo-com",
        title: "default.mediaFeatures.3.title",
        description: "default.mediaFeatures.3.description"
      },
      {
        id: "4",
        icon: "data-folder-svgrepo-com",
        alt: "data-folder-svgrepo-comP",
        title: "default.mediaFeatures.4.title",
        description: "default.mediaFeatures.4.description"
      },
      {
        id: "5",
        icon: "recycling-recycle",
        alt: "recycling-recycle",
        title: "default.mediaFeatures.5.title",
        description: "default.mediaFeatures.5.description"
      }
      ],

      swiperOption: {
        slidesPerView: 6,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 6
          }
        },
        spaceBetween: 20
      },

      counterItems: [
        {
          alt: 'bag',
          width: '70px',
          icon: 'bag-w.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 100000,
          duration: 3000,
          title: 'ourPartner.bag',
          subTitle: 'ourPartner.distributed',
          perDay: 'ourPartner.perDay'
        },
        {
          alt: 'bread',
          width: '70px',
          icon: 'bread.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 500,
          duration: 4000,
          title: 'ourPartner.partners',
          subTitle: 'ourPartner.intunisia',
          perDay: ''
        },
        {
          alt: 'capsules',
          width: '70px',
          icon: 'capsules.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 3,
          duration: 4000,
          title: 'ourPartner.cibles',
          subTitle: 'ourPartner.ciblesPer',
          perDay: ''
        }
      ]


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },
  },

  watch:{
    mediaFeaturesVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },
    iconsVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },

    counterVisible(newValue) {
      if (newValue) {
        this.keyCounterVisible ++
      }
    }
  },

  mounted() {
    this.findBanner(this.windowWidth);
    this.initIntersectionObserver()
    this.initIntersectionObserverIconsSection()
    this.observeImages()
    this.observeImagesRight()
    this.initIntersectionCounterObserver()
  },

  methods: {

    initIntersectionCounterObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.counterVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.counterSection);
    },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    initIntersectionObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.mediaFeaturesVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },

    initIntersectionObserverIconsSection() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.iconsSection = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },


    observeImagesRight() {
      const images = document.querySelectorAll('.image-slide-right-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, 
      { threshold: 0.1,}
    );

      images.forEach(image => {
        observer.observe(image);
      });
    },

    observeImages() {
      const images = document.querySelectorAll('.image-slide-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    },
    
    observeIcons() {
      const images = document.querySelectorAll('.fadeInUp');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    }

  }
};
</script>

<template>
  <Layout>

    <!-- Main Banners -->
    <div class="row pt-xl-0" >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-primary"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-secondary">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <div class="banner-overlay"></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left d-none d-md-block">
                   
                    <h1 class="font-weight-bold banner-title text-white text-uppercase" style="font-size:3rem !important;"><span class="text-white">PU</span><span class="text-white">B</span><span class="text-white">AG</span> <sup>®</sup></h1>
                    <h1 class="d-none d-sm-block text-white mt-4 banner-title"> {{ $t('default.bannerTitle') }} </h1>

                  <h2 class="d-none d-lg-block text-white font-weight-bold font-size-24 mt-3 mb-5 banner-title" style="max-width: 50%;">
                    {{ $t('default.bannerSubTitle1') }}
                  </h2>

                  <h2 class="d-none d-lg-block text-white font-weight-bold font-size-22 mt-2 banner-title" style="max-width: 50%;">
                    {{ $t('default.bannerSubTitle2') }}
                  </h2>


                  <div class="mt-4">
                    <a class="pr-3" href="/devis">
                      <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18">
                        <div class="font-weight-normal font-size-12">{{ $t('default.bannerLabelButton1') }}</div>
                        {{ $t('default.bannerButton1') }} 
                      </b-button>
                    </a>    
                    
                    <a class="pl-3" href="/devenir-partenaire">
                      <b-button variant="light"  style="padding: 10px 26px; " class="font-weight-bold font-size-18">
                        <div class="font-weight-normal font-size-12">{{ $t('default.bannerLabelButton2') }} </div>
                        {{ $t('default.bannerButton2') }} 
                      </b-button>   
                    </a>
                  </div>
                </div>
                
              
            </b-carousel>



        </div>
      </div>


    </div>


      <div  class="text-left pt-4 p-3 d-md-none d-block bg-light">
          <img src="@/assets/images/logo.png" class="mt-4" alt height="30" />
          <!-- <h1 class="font-weight-bold banner-title-white text-dark text-uppercase"  ><span class="text-dark">Pu</span><span class="text-dark">b</span><span class="text-dark">ag</span> <sup>®</sup></h1> -->
          <h3 class="d-md-none d-block text-dark mt-4 banner-title-mobile" style="font-size:1.6rem !important;">{{ $t('default.bannerTitle') }}</h3>

        <h2 class="d-md-none d-block text-dark font-weight-bold font-size-20 mt-3 mb-4 banner-title-mobile" style="max-width: 100%;">
          {{ $t('default.bannerSubTitle1') }}
        </h2>

        <h2 class="d-md-none d-block text-dark font-weight-bold font-size-18 mt-5 banner-title-mobile" style="max-width: 100%;">
          {{ $t('default.bannerSubTitle2') }}
        </h2>

        

        <div class="mt-4 text-center">
          <a href="/devis">
            <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold mt-4 font-size-18 w-100">
              <div class="font-weight-normal font-size-12">{{ $t('default.bannerLabelButton1') }} </div>
              {{ $t('default.bannerButton1') }} 
            </b-button>
          </a>    
          
          <a href="/devenir-partenaire">
            <b-button variant="secondary"  style="padding: 10px 26px; " class="font-weight-bold font-size-18 mt-3 w-100">
              <div class="font-weight-normal font-size-12">{{ $t('default.bannerLabelButton2') }}  </div>
              {{ $t('default.bannerButton2') }} 
            </b-button>   
          </a>
        </div>

      </div>

    <!-- 5 points section -->
    <div class="pt-4 text-center bg-white ">
      
      <div class="pt-5 text-dark font-weight-bold " style="font-size:2.5rem;">
        {{$t("default.title")}}
      </div>

      <hr class="separator-line mt-3 mb-3">


      <div class="header-60-width font-size-20 mx-auto text-dark text-wrap mt-5 text-md-center text-justify" >
        <strong>{{$t("default.companyName")}} </strong>  {{$t("default.subTitle")}}
      </div>

      <div class="header-60-width font-size-20 mx-auto text-info font-weight-bold text-wrap mt-md-1 mt-3  text-md-center text-justify" >
        {{$t("default.subTitle2")}}
      </div>

    </div>


    <div class="bg-white pt-md-5 pt-md-5 pt-3 pb-5">
          <div ref="mediaFeaturesSection" class="header-60-width row pt-md-4 pt-1 text-center justify-content-center ">
            <div 
              v-for="(feature, index) in mediaFeatures" 
              :key="feature.id"  
              class="col-md-4 col-12 mb-4 mt-4 pr-4 pl-4 fadeInUp" 
              :style="{ animationDelay: (index * 0.05) + 's' }"
              ref="mediaFeatureElements"
            >
              <img 
                :alt="feature.alt" 
                class="mb-2" 
                v-if="feature.icon" 
                :src="require('@/assets/icons/' + feature.icon + '.svg')" 
                width="50px"
              > 
              <h4 class=" mt-3 mb-2 font-weight-bold text-primary text-uppercase">{{ $t(feature.title) }}</h4>
              <p class="mt-4 text-dark font-size-14 text-center">{{ $t(feature.description) }}</p>
            </div>
        </div>

    </div>


    <!--  Counter Section  -->
    <div class="bg-white pt-md-5 pt-3 pb-5">

      <div class="bg-primary p-md-5 p-3">
          <h3 class="text-white text-center font-weight-bold mt-2 banner-title " > 
                <span style="font-size:2rem; letter-spacing: 2px;" class="d-none d-md-inline">Démarquez-vous grâce à notre support innovant</span>
                <span style="font-size:1.7rem; letter-spacing: 2px;" class="d-md-none">Un Support Innovant</span>
          </h3>

          <!-- <h3 class="text-white text-center font-weight-bold mt-2 banner-title" style="font-size:2rem; letter-spacing: 2px;"> 
            Ne ratez plus vos clients par manque de visibilité
          </h3> -->

          <div class="text-white font-size-16 mt-5 text-md-center text-justify" style="letter-spacing: 0.08em; line-height: 1.8;">
            <span class="text-uppercase"> {{$t("default.legend")}}  </span>
            <span > {{$t("default.fieldsetBody01P1")}}  </span>
            <div>{{$t("default.fieldsetBody01P2")}}</div>
          </div>


                <div ref="counterSection" class="mt-md-5 mt-4 text-white">
            <div>
                <div class="row p-md-4 -0">
                  <div class="col-12 text-center">
                      <div class="row ml-md-4 ml-0 mr-md-4 mr-0 pt-3 pb-3">
                      <div 
                          v-for="(item, index) in counterItems" 
                          :key="index" 
                          class="col-md-4 col-12 text-center pt-md-0 pt-4 pb-md-0 pb-4 "
                      >
                          <!-- <h2>
                          <img :alt="item.alt" :width="item.width" :src="require(`@/assets/icons/${item.icon}`)   " class="mr-0" />
                          </h2> -->

                          <span class="font-size-16 d-none d-sm-block">
                            <i>{{ $t(item.moreThanText) }}</i>
                          </span>

                          <countTo 
                          :key="keyCounterVisible"
                          class="m-2 banner-title text-white " 
                          style="font-weight:900;" 
                          :autoplay="counterVisible" 
                          separator=" " 
                          :startVal="0" 
                          :endVal="item.endVal" 
                          :duration="item.duration"
                          />

                          <h2 class="text-center mt-2 text-white text-uppercase">{{ $t(item.title) }}</h2>
                          <h2 class="text-center text-white">
                          <span class="text-uppercase" style="font-weight:900px;">{{ $t(item.subTitle) }}</span>
                          <span class="text-center text-white" style="font-weight:400px;">{{ $t(item.perDay) }}</span>
                          </h2>
                      </div>
                      </div>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12 text-center">
                    <a class="pr-3" href="/devis">
                      <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18">
                        <div class="font-weight-normal font-size-12">{{ $t('default.bannerLabelButton1') }} </div>
                        {{ $t('default.requestQuote') }}
                      </b-button>
                    </a>  
                  </div>
                </div>

            </div>
            </div>


      </div>


    </div>


    
    
    <!-- Interactive Section -->
    <div class="bg-white pt-md-5 pt-3 pb-5">


      <div class="text-dark text-center font-weight-bold " style="font-size:2.5rem;">
        {{$t("default.interactive")}} 
      </div>

      <hr class="separator-line mt-3 mb-3">


      <div class="mt-5 mb-5">
      


      <div class="header-60-width  row mt-5 align-items-center"> 
        <div class="col-md-6 col-12 text-center">
          <img  class="mt-2 mb-md-0 mb-5 image-slide-in" src="@/assets/images/team-map-position.png" alt="team-map-position" />
        </div>
        <div class="col-md-6 col-12">
          <div class="font-size-22 font-weight-bold text-primary text-uppercase " >
            {{$t("default.campagneNeeds")}} 
          </div>

          <div class="font-size-16 mt-4 text-dark text-justify p-0 pm-4" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t("default.outil")}} 
            <strong>{{$t("default.companyName")}}</strong> 
            {{$t("default.interactiveDescription")}} 
          </div>

          <router-link to="/concept-sacs-publicitaires">
              <b-button variant="primary" class="mt-4 pr-4 pl-4 text-uppercase font-size-16">
                <span class=" text-white text-uppercase font-weight-bold"> {{$t("default.bonceptButton")}} 
                </span> 
              </b-button>
            </router-link>
        </div>
      </div>
    </div>

    <div class="mt-5 mb-5">

<div class="header-60-width row  align-items-center pt-5 "> 
 
        <div class="col-md-6 col-12 p-md-5 p-0">
          <div class="font-size-22 font-weight-bold text-primary text-uppercase " >
            {{$t("default.campagnesBenefits")}} 
          </div>

          <div class="font-size-16 mt-4 text-dark text-justify" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t("default.campagnes")}}  

            <strong>{{$t("default.companyName")}}</strong> 
            {{$t("default.campagnesDescription")}} 
          </div>

          <router-link to="/atouts-sacs-publicitaires">
            <b-button variant="primary" class="mt-4 pr-4 pl-4 text-uppercase font-size-16">
              <span class=" text-white text-uppercase font-weight-bold">{{$t("default.atoutsButton")}} </span> 

              </b-button>
            </router-link>
        </div>

        <div class="col-md-6 col-12 text-md-right text-center p-md-5 p-0 pt-md-0 pt-5">
          <img  class="mt-2 image-slide-right-in dashboard-image" src="@/assets/images/dashboard.png" alt="atout" />
        </div>












</div>
    </div>
    </div>



    <!-- <div ref="iconsSection" class="header text-center pb-5">
        <div>
          <div class="rubon78">
            <div class="image-overlay">
              <div class="text-white mt-4 text-uppercase" style="font-size:50px">
                <strong>{{$t("default.companyName")}}</strong>
                <span class="ml-2" style="font-size:40px">{{$t("default.invite")}}</span>
              </div>

              <div class="mt-2 text-center text-uppercase" style="font-size:25px; max-width: 400px; margin: 0 auto; color:#f7d584">
                {{$t("default.description01")}}
              </div>


              <div class="header-60-width row text-center mt-4 d-md-flex d-none">
                <div v-for="(icon, index) in icons" :key="index" class="text-center col-3 fadeInUp" :class="'icon' + (index + 1)"
                :style="{ animationDelay: (index * 0.2) + 's' }"
                >
                  <div class="circle-icon"> 
                    <img width="60px" class="mt-2" :src="require('@/assets/icons/' + icon.imgSrc + '.svg')" :alt="icon.altText" />
                  </div>
                  <div class="text-white font-size-16 mt-2">
                    {{ $t(icon.text) }}
                  </div>
                </div>
              </div>

              
            </div>
          </div>


            <div class="white-box text-center">
              <div class="p-2">

                <fieldset class="scheduler-border">
                  <legend class="scheduler-border text-primary text-center text-uppercase">
                    {{$t("default.legend")}}
                  </legend>
                  <div class="control-group text-center">
                    <div class="font-size-16 mt-2">
                      {{$t("default.fieldsetBody01")}}

                    </div>

                    <div class="font-size-24 mt-2 text-uppercase font-weight-bold text-primary " style="">
                      {{$t("default.fieldsetBody02")}}    
                    </div>     
                    <div class="font-size-24 text-uppercase font-weight-bold text-primary " style="">
                      {{$t("default.fieldsetBody03")}}      
                    </div>
                  </div>
                </fieldset>

              </div>

            </div>





            <div>
              <div >
                <h1 class=" text-white text-wrap">
                  {{$t("default.needs")}} 
                </h1>
              </div>

              <hr class="separator-line mt-5">

              <div class="mt-4">
                <h6 class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
                  {{$t("default.needsDescription")}} 
                </h6>
              </div>

            <router-link to="/devis">
              <b-button class="mt-4 pr-4 pl-4 text-uppercase font-size-18" style="background-color: #f7d584;">
                <span class=" text-primary">{{$t("default.requestQuote")}} </span> 
              </b-button>
            </router-link>
            <div class="font-size-12 mt-1 text-uppercase" style="color: #f7d584;">
              {{$t("default.requestQuoteResponse")}} 
          </div>

          </div>

        </div>
    </div> -->


  
  
    
    <!-- New Partner -->
    <div class="bg-white pt-md-5 pt-3">
        <div class="bg-primary">

            <div class="row">

              <div class="col-lg-6 col-12 d-none d-lg-flex align-items-center justify-content-center">
                <img  class="" src="@/assets/images/become-partner-banner.jpg" alt="Partaires PUBAG" width="100%"  />

              </div>

              <div class="col-lg-6 col-12 text-white p-md-5 p-3 my-auto">
                <h3 class="ml-2 text-white text-center font-weight-bold" style="font-size:2.3rem">{{$t("default.inviteBecomePartner")}}</h3>

                <h5 class="text-center text-white mt-3 pb-4 font-weight-bold">
                  {{$t("default.slogans1")}}
                </h5>

                
                <p class="text-white mt-5 text-justify font-size-16 font-weight-bold" style="letter-spacing: 2px; line-height: 2;">
                  {{$t("default.becomePartnerDescription")}}
                </p>

                <!-- <span class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
                  {{$t('ourPartner.subtitle1')}}
                </span> -->

                <div class="d-flex justify-content-center mt-5 pt-5">
                  <a href="/devenir-partenaire">
                  <b-button variant="light" style="padding: 10px 26px;" class="font-weight-bold font-size-18">
                    <div class="font-weight-normal font-size-12">{{ $t("default.labelbecomePartnerPubag") }}</div>
                    {{ $t("default.becomePartnerPubag") }}
                  </b-button>
                  </a>
                </div>


                

              </div>


              

            </div>

        </div>
    </div>

    <!-- <div class="header text-center pb-5 ">

      <div class="rubon79">
            <div class="image-overlay">
              <div class="text-white mt-4 text-uppercase" style="font-size:50px">
                <strong>{{$t("default.companyName")}}</strong>
                <span class="ml-2" style="font-size:40px">{{$t("default.inviteBecomePartner")}}</span>




               




              </div>

              <div class="mt-2 text-center text-uppercase header-60-width" style="font-size:25px; margin: 0 auto; color:#f7d584">
                {{$t("default.slogans1")}}
              </div>

  
            </div>
          </div>


          <div class="white-box text-center">
              <div class="p-2">

                <fieldset class="scheduler-border">
                  <legend class="scheduler-border text-primary text-center text-uppercase">
                    {{$t("default.legend")}}
                  </legend>
                  <div class="control-group text-center">
                    <div class="font-size-16 mt-2">
                      {{$t("default.becomePartnerDescription")}}

                    </div>

                    <div class="font-size-24 mt-2 text-uppercase font-weight-bold text-primary " style="">
                      {{$t("default.slogans2")}}   
                    </div>     

                  </div>
                </fieldset>

              </div>

            </div>


      <div class="header-60-width">

          <div>
              <h6 class="header-60-width mx-auto text-light text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
                {{$t('ourPartner.subtitle1')}}
                <strong>{{$t('ourPartner.companyName')}}</strong>
              </h6>
          </div>

          <router-link to="/devenir-partenaire">
              <b-button class="mt-4 pr-4 pl-4 text-uppercase font-size-18" style="background-color: #f7d584;">
                <span class=" text-primary">{{$t("default.becomePartner")}}</span> 
              </b-button>
            </router-link>
      </div>
    </div> -->

    <!-- NOS REFERENCES -->
    <div class="bg-white pt-md-5 pt-3">
        <div class=" ">

          <div class="text-dark text-center font-weight-bold " style="font-size:2.5rem;">
              Nos références
            </div>

            <hr class="separator-line mt-3 mb-3">

            <div class="container py-5 p-2">
            <swiper :options="swiperOption" class="reference-swiper">
              <swiper-slide v-for="(logo, index) in referencesLogos" :key="index">
                <div class="card border-0 shadow-sm text-center p-3 logo-card">
                  <img :src="logo.src" :alt="logo.alt" class="img-fluid mx-auto d-block logo-img" />
                </div>
              </swiper-slide>
            </swiper>
          </div>

            <!-- <div class="row justify-content-center align-items-center">
              <div 
              v-for="(logo, index) in referencesLogos" 
              :key="index" 
              class="col-md-2 col-4 mb-4"
              >
              <div class="reference-logo-container">
                <img 
                :src="logo.src" 
                :alt="logo.alt" 
                class="img-fluid reference-logo"
                />
              </div>
              </div>
            </div> -->
        </div>
    </div>

  </Layout>
</template>

<style scoped>




.banner-overlay {
  background: linear-gradient(#61b08383, rgba(0, 0, 0, 0.5)); 
  background-size: cover;
  background-position: center;
  
  /* Create a slight blur effect */
  filter: blur(5px);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  text-align: center;
  
  transition: filter 0.3s ease, opacity 0.3s ease;
}

/* Hover Effect (Optional: Adds a modern interaction on hover) */
/* .banner-overlay:hover {
  filter: blur(5px);
  opacity: 0.8; 
} */

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}
@media (min-width: 768px) {
  .banner-title {
    font-size: 4rem;
  }
}

/* Mobile Version */

.banner-title-dark {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #121212; font-weight: 700;
}
.banner-title-mobile {
  font-size:2rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff; 
  font-weight: 700;
}





.carousel-caption {
  position: absolute;
  padding-left: 5%;
  top: 48%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 768px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.left-border {
  border-left: 3px solid #137437;
  padding-left: 10px;
}


.header {
    background:  linear-gradient(19deg,#37985b 0%,#137437 , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 70%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437; /*#f7d584 ;*/
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}



</style>

<style scoped>
.logo-card {
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #fff;
}
.logo-card:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}
.logo-img {
  max-height: 60px;
  object-fit: contain;
}
.swiper-container {
  padding-bottom: 20px;
}
</style>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fadeInUp {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fadeInUp.animate {
  animation: fadeInUp 0.6s ease-in-out forwards;
}
</style>

<style scoped>
.rubon78 {
  background-image: url('~@/assets/images/rubon78.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
}

.rubon79 {
  background-image: url('~@/assets/images/become-partner-banner.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
}






.image-overlay {
  background: #294639c9  ; 
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
}


</style>


<style scoped>
.circle-icon {
  display: inline-block;
  background-color: #252525;
  border-radius: 50%;
  padding: 20px;
  width: 120px;
  height: 120px; 
  opacity: 0.7;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.circle-icon img {
  width: 60px;
  height: 60px; 
}

.white-box {
  background-color: #fff;
  max-width: 600px;
  transform: translateY(-100px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
}

fieldset.scheduler-border {
  border: 2px solid #137437;
  padding: 1.5em;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

legend.scheduler-border {
  font-size: 1.4em;
  font-weight: bold;
  color: #137437;
  padding: 0 10px;
  text-align: center;
}

.control-group {
  margin-top: 10px;
  line-height: 1.6;
}



</style>


<style scoped>
.image-slide-in {
  width: 400px;
  transform: translateX(-100%);
  opacity: 0; 
  transition: transform 1s ease-out, opacity 1s ease-out;
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}

.dashboard-image {
    width: 100%;
    max-width: 600px;
    border: 8px solid #137437;
    border-radius: 10px;
    box-shadow: 0 10px 20px #13743793;
    transform: rotate(0deg); /* Initial rotation */
    transition: transform 1s ease-out, box-shadow 1s ease-out; /* Add transition for rotation */
}

.image-slide-right-in {
    width: 600px;
    transform: translateX(100%); /* Initially off-screen to the right */
    opacity: 0;
    transition: transform 1s ease-out, opacity 1s ease-out; /* Sliding effect */
}

.image-slide-right-in.animate {
    transform: translateX(0) rotate(0deg); /* Slide to normal position and apply rotation */
    opacity: 1;
}

@media (max-width: 450px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 270px;
  }
}

@media (min-width: 450px) and (max-width: 1300px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 360px;
  }
}


  </style>